import React, { useRef } from 'react';
import useIntersectionObserver from '@react-hook/intersection-observer';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const LazyLoadVideo = ({ children, className }: Props) => {
  const containerRef = useRef<HTMLElement>();
  const lockRef = useRef(false);
  const { isIntersecting } = useIntersectionObserver(containerRef);
  if (isIntersecting) {
    lockRef.current = true;
  }
  return (
    <div ref={containerRef} className={className}>
      {lockRef.current ? children : <video />}
    </div>
  );
};
export default LazyLoadVideo;
